import { Component, EventEmitter, Output } from '@angular/core';
import { BiqButtonComponent } from '../biq-button/biq-button.component';
import { analytics } from '@app/events/segment/analytics';

@Component({
  selector: 'app-biq-start-page',
  imports: [
    BiqButtonComponent,
  ],
  templateUrl: './start-page.component.html',
  styleUrl: './start-page.component.css'
})
export class StartPageComponent {
  @Output() startEmitter: EventEmitter<void> = new EventEmitter<void>();

  onClickStartBtn() {
    analytics.track('BIQ Start',{section : 'biq'});
    this.startEmitter.emit();
  }
}
